/* eslint-disable */ import React, { useState, useEffect } from "react";
import { Table, Pagination, Space, Button, Tag, DatePicker, notification } from "antd";
import './payment.css';
import { useSelector, useDispatch } from "react-redux";

import ExportExcel from '../../../shared/ExcelExport/exportExcel';
import { tutorPayouts } from '../../../../globalConstant';
import { POST } from '../../../../apiClient';
import moment from 'moment';

const columns = [

 
  {
    title: "Payout Transaction Date",
    // dataIndex:"month",
    width: "20%",
    key:"month",
    render: (text, record) => (
      <Space size="middle" key={text.month}>
        
     {text.payoutTransferDate > 0 && `${text.payoutTransferDate}/`}{moment({month: text.month, year: text.year}).format('MMMM, YYYY')}
       
      </Space>


    )
  },
  {
    title: "Payout Transfer Date",
    // dataIndex:"month",
    width: "20%",
    key:"month",
    render: (text, record) => (
      <Space size="middle" key={text.month}>
        
     {text.payoutTransferDate > 0 ? `${text.payoutTransferDate}` : 'N/A'}
       
      </Space>


    )
  },
  {
    title: "Amount",
    dataIndex: "totalAmount",
    width: "20%",
    key:"totalAmount"
  },
  {
    title: "Status",
    key:"isPayoutGiven",
    dataIndex:"isPayoutGiven",
    width: "20%",

    render: (text, record) => (
      <Space size="middle" key={text.isPayoutGiven}>
        <Tag color={text.isPayoutGiven ? 'green' : 'volcano'}>
          {text.isPayoutGiven ? 'Paid' : 'Pending'}
        </Tag>
      </Space>


    )
  },

];

const Payment = () => {

  const dispatch = useDispatch();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [listing, setListing] = useState();
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(1);



  const [pagination, setPagination] = useState(
    {
      current: 1,
      pageSize: 5,
      total: 25,
    }
  )

  useEffect(() => {
    getTransactions();

  }, [limit, offset]);

  const getTransactions = () => {
    dispatch({ type: "LOADING", payload: true });
    let params = {
      limit, offset
    }
    POST(tutorPayouts, params).then(res => {
      

      if (res.status === 200) {
        setListing(res.data.data.tutorPayouts);
        setTotalRecords(res.data.data.totalCount);
        setPagination({ ...pagination, total: res.data.data.totalCount });
      

      }
      if (res.status === 500) {
        notification.error({ message: res.err.error.message });
      }

      dispatch({ type: "LOADING", payload: false });
    })
  }
  const handleTableChange = (paginations, filters, sorter) => {
   
    setOffset((paginations.current * paginations.pageSize) - paginations.pageSize);
    setLimit(paginations.pageSize);
  };
  const onChange = (date, dateString) => {
  
  }
 
  return (
    <div className="mx-3">
      {/* <div className="py-3 float-right d-flex">
        <div className="mr-2"><ExportExcel data={data} /> </div>
        <DatePicker onChange={onChange} /></div> */}
      <Table

        columns={columns}
        rowKey={(record) => record._id}
        dataSource={listing}
        pagination={pagination}
        // loading={loading}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Payment;
